import * as React from 'react'

export function useToggleRatings() {
  React.useEffect(() => {
    const revealButtons = document.querySelectorAll<HTMLButtonElement>('.js-reveal-ratings-button')

    function onToggleRatingsClick(ev: MouseEvent) {
      ev.preventDefault()

      const button = ev.currentTarget as HTMLElement
      const ratingsRowWithTable = button.previousElementSibling

      ratingsRowWithTable?.querySelectorAll('table tr').forEach((rating, index, rows) => {
        if (rating.classList.contains('is-last')) {
          rating.classList.remove('is-last')
        }

        rating.classList.remove('hidden')

        if (index === rows.length - 1) {
          rating.classList.add('is-last')
        }
      })

      button.classList.add('hidden')
      window.gtag && window.gtag('event', 'click', { event_category: 'reveal-ratings' })
    }

    revealButtons.forEach((button) => button.addEventListener('click', onToggleRatingsClick))

    return () => {
      revealButtons.forEach((button) => button.removeEventListener('click', onToggleRatingsClick))
    }
  }, [])
}
